/**
 * Extract the HTTP status from a thrown API error. Works both for the generated
 * client (which throws the `HttpResponse`, carrying `.status`) and for axios
 * errors (which carry `.response.status`).
 */
export function httpStatusFromError(error: unknown): number | undefined {
  if (error && typeof error === 'object') {
    const e = error as { status?: number; response?: { status?: number } };
    if (typeof e.status === 'number') return e.status;
    if (typeof e.response?.status === 'number') return e.response.status;
  }
  return undefined;
}

/**
 * Pick the most useful error message id for a failure. Well-known infrastructure
 * statuses get a specific, more helpful message; everything else (including 400
 * domain/validation errors) keeps the caller's own `fallbackId`, which is
 * usually more meaningful than a generic HTTP message.
 */
export function errorMessageId(error: unknown, fallbackId?: string): string {
  const status = httpStatusFromError(error);
  if (status === 401 || status === 403) return 'error-forbidden-message';
  if (status === 404) return 'error-not-found-message';
  if (status !== undefined && status >= 500) return 'error-server-message';
  return fallbackId ?? 'unexpected-error-message';
}
